const AUTH_ERROR_TITLE = 'Fehler beim Anmelden'
const REGISTER_ERROR_TITLE = 'Fehler beim Registrieren'

const error = {
  // Auth
  'auth/empty-values': {
    title: AUTH_ERROR_TITLE,
    message: 'Bitte überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort.',
  },
  'auth/wrong-password': {
    title: AUTH_ERROR_TITLE,
    message: 'Bitte überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort.',
  },
  'auth/invalid-email': {
    title: AUTH_ERROR_TITLE,
    message: 'Bitte überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort.',
  },
  'auth/user-disabled': {
    title: AUTH_ERROR_TITLE,
    message: 'Dieser Account wurde gesperrt.',
  },
  'auth/user-not-found': {
    title: AUTH_ERROR_TITLE,
    message: 'Bitte überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort.',
  },
  // Register
  'auth/registration-code-invalid': {
    title: 'Code ungültig',
    message:
      'Bitte überprüfen Sie Ihren Code und versuchen Sie es noch einmal.',
  },
  'auth/registration-data-invalid': {
    title: REGISTER_ERROR_TITLE,
    message:
      'Es gab einen Fehler beim Registrieren. Bitte überprüfen Sie Ihre Angaben oder versuchen Sie es später noch einmal.',
  },
  'auth/email-already-in-use': {
    title: 'E-Mail bereits vergeben',
    message:
      'Diese E-Mail-Adresse wird bereits von einem anderen Account verwendet. Bitte nutzen Sie eine andere.',
  },
  'auth/invalid-email': {
    title: REGISTER_ERROR_TITLE,
    message:
      'Es gab einen Fehler beim Registrieren. Bitte überprüfen Sie Ihre Angaben oder versuchen Sie es später noch einmal.',
  },
  'auth/operation-not-allowed': {
    title: REGISTER_ERROR_TITLE,
    message:
      'Es gab einen Fehler beim Registrieren. Bitte überprüfen Sie Ihre Angaben oder versuchen Sie es später noch einmal.',
  },
  'auth/weak-password': {
    title: REGISTER_ERROR_TITLE,
    message:
      'Dieses Passwort ist zu schwach. Es sollte mindestens aus 6 Zeichen bestehen. Bitte überprüfen Sie Ihre Angaben oder versuchen Sie es später noch einmal.',
  },
  'auth/no-access-token': {
    title: 'Fehler beim Authentifizieren',
    message:
      'Es gab einen Fehler beim Authentifizieren. Bitte versuche es später noch einmal.',
  },
  // User
  'change-email/error': {
    title: 'Fehler',
    message:
      'Es gab einen Fehler beim Ändern der E-Mail-Adresse. Bitte versuchen Sie es später noch einmal.',
  },
  'change-password/error': {
    title: 'Fehler',
    message:
      'Es gab einen Fehler beim Zurücksetzen des Passwortes. Bitte versuche es später noch einmal.',
  },
}

export default error
